import { useEffect } from "react";

/**
 * JsonLd — injects a schema.org structured-data <script type="application/ld+json">
 * into <head>. Removes itself on unmount. Used to boost SEO rich snippets.
 */
export default function JsonLd({ id, data }) {
  useEffect(() => {
    if (!data) return undefined;
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.id = id || "jsonld";
    s.text = JSON.stringify(data);
    document.head.appendChild(s);
    return () => {
      const el = document.getElementById(s.id);
      if (el) el.remove();
    };
  }, [id, data]);
  return null;
}
